const NAMES = {
  acceptLanguage: "Accept-Language",
};

export { NAMES };
